import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { setStyleProperty as _$setStyleProperty } from "solid-js/web";
import { className as _$className } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<span class=hud__chip-realism data-testid=hud-realism-chips>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<ul class=hud__objectives data-testid=hud-objectives>`),
  _tmpl$3 = /*#__PURE__*/_$template(`<div class=hud__mission>`),
  _tmpl$4 = /*#__PURE__*/_$template(`<dl class="hud__gauges hud__gauges--left"><div class=hud__gauge><dt>Airspeed</dt><dd><strong data-testid=hud-airspeed></strong> mph</dd></div><div class=hud__gauge><dt>Altitude</dt><dd><strong data-testid=hud-altitude></strong> ft</dd></div><div class=hud__gauge><dt>Heading</dt><dd><strong data-testid=hud-heading></strong>° `),
  _tmpl$5 = /*#__PURE__*/_$template(`<dl class="hud__gauges hud__gauges--right"><div class=hud__gauge><dt>Throttle</dt><dd><strong data-testid=hud-throttle></strong></dd></div><div class=hud__gauge><dt>Fuel</dt><dd><strong data-testid=hud-fuel></strong></dd></div><div class=hud__gauge><dt>Ammunition</dt><dd><strong data-testid=hud-ammo></strong> rds`),
  _tmpl$6 = /*#__PURE__*/_$template(`<div class=hud__callout><span>`),
  _tmpl$7 = /*#__PURE__*/_$template(`<span class=hud__paused>PAUSED`),
  _tmpl$8 = /*#__PURE__*/_$template(`<div class=hud aria-live=off><div class=hud__chip><span class=hud__chip-name></span></div><ul class=hud__messages data-testid=hud-messages></ul><div class=hud__footer><span>`),
  _tmpl$9 = /*#__PURE__*/_$template(`<span class=hud__chip-mission data-testid=hud-mission-title>`),
  _tmpl$0 = /*#__PURE__*/_$template(`<span class=hud__chip-tag>`),
  _tmpl$1 = /*#__PURE__*/_$template(`<span class=hud__objective-progress>`),
  _tmpl$10 = /*#__PURE__*/_$template(`<div class=hud__objective data-testid=hud-objective><span class=hud__objective-tag>OBJECTIVE</span><span class=hud__objective-text>`),
  _tmpl$11 = /*#__PURE__*/_$template(`<span class=hud__objectives-progress>`),
  _tmpl$12 = /*#__PURE__*/_$template(`<li><span class=hud__objectives-mark></span><span class=hud__objectives-label>`),
  _tmpl$13 = /*#__PURE__*/_$template(`<div class=hud__mission-verdict data-testid=hud-mission-outcome>`),
  _tmpl$14 = /*#__PURE__*/_$template(`<div class=hud__waypoint data-testid=hud-waypoint><span class=hud__waypoint-arrow>↑</span><span class=hud__waypoint-text><strong data-testid=hud-waypoint-label></strong><span>`),
  _tmpl$15 = /*#__PURE__*/_$template(`<div class=hud__bombs data-testid=hud-bombs><span class=hud__bombs-tag>BOMBS</span><span class=hud__bombs-count><strong data-testid=hud-bombs-remaining></strong> of `),
  _tmpl$16 = /*#__PURE__*/_$template(`<div class=hud__damage data-testid=hud-damage><span class=hud__damage-tag>Airframe</span><span class=hud__damage-bar aria-hidden=true><span class=hud__damage-fill></span></span><strong data-testid=hud-damage-airframe>%</strong><span class=hud__damage-hits data-testid=hud-damage-hits>Hit <!> · Scored `),
  _tmpl$17 = /*#__PURE__*/_$template(`<span class=hud__damage-warn>`),
  _tmpl$18 = /*#__PURE__*/_$template(`<div class=hud__contact data-testid=hud-contact><span class=hud__contact-arrow>↑</span><span class=hud__contact-text><strong data-testid=hud-contact-range></strong><span> · `),
  _tmpl$19 = /*#__PURE__*/_$template(`<li>`),
  _tmpl$20 = /*#__PURE__*/_$template(`<div class=hud__outcome data-testid=hud-outcome role=status><p class=hud__outcome-title></p><button class=hud__outcome-button type=button>Return to title`);
import { For, Show } from "solid-js";
import { damageReportOf } from "./combat-hud.ts";
import { realismChipsVisible } from "./hud-format.ts";
import { missionOutcomeLine, OBJECTIVE_MARKS } from "./mission-hud.ts";

/**
 * The in-flight overlay. Deliberately DOM rather than drawn into the WebGPU
 * canvas: text stays crisp at any pixel ratio, and it is inspectable by the
 * headless browser check.
 *
 * The digital corner gauges (airspeed/altitude/heading, throttle/fuel/ammo)
 * duplicate the cockpit panel's analogue instruments (`CockpitPanel.tsx`)
 * once that panel is actually on screen and REALISTIC INSTRUMENTS is on —
 * `hideDigitalGauges` (computed by `Fly.tsx` as `cameraMode === "cockpit" &&
 * realisticInstruments`) tucks them away for exactly that combination, so
 * chase/fly-by (no panel visible) and REALISTIC INSTRUMENTS off (the
 * "all possible instruments" / helper pairing) both keep the full digital
 * readout. The message feed, contact/waypoint readouts and outcome banner
 * stay up regardless — only the two redundant numeric `<dl>`s move aside.
 */
export function HudOverlay(props) {
  return (() => {
    var _el$ = _tmpl$8(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$34 = _el$2.nextSibling,
      _el$35 = _el$34.nextSibling,
      _el$36 = _el$35.firstChild;
    _$insert(_el$2, _$createComponent(Show, {
      get when() {
        return props.mission;
      },
      children: mission => (() => {
        var _el$38 = _tmpl$9();
        _$insert(_el$38, () => mission().title);
        return _el$38;
      })()
    }), _el$3);
    _$insert(_el$3, () => props.aircraft);
    _$insert(_el$2, _$createComponent(For, {
      get each() {
        return props.chips;
      },
      children: chip => (() => {
        var _el$39 = _tmpl$0();
        _$insert(_el$39, chip);
        return _el$39;
      })()
    }), null);
    _$insert(_el$2, _$createComponent(Show, {
      get when() {
        return _$memo(() => !!props.realismChips?.length)() && realismChipsVisible(props.hud.timeS);
      },
      get children() {
        var _el$4 = _tmpl$();
        _$insert(_el$4, _$createComponent(For, {
          get each() {
            return props.realismChips ?? [];
          },
          children: chip => (() => {
            var _el$40 = _tmpl$0();
            _$insert(_el$40, chip);
            return _el$40;
          })()
        }));
        return _el$4;
      }
    }), null);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return props.mission;
      },
      get children() {
        var _el$5 = _tmpl$3();
        _$insert(_el$5, _$createComponent(Show, {
          get when() {
            return props.mission?.objective;
          },
          children: objective => (() => {
            var _el$41 = _tmpl$10(),
              _el$42 = _el$41.firstChild,
              _el$43 = _el$42.nextSibling;
            _$insert(_el$43, () => objective().label);
            _$insert(_el$41, _$createComponent(Show, {
              get when() {
                return objective().progress;
              },
              get children() {
                var _el$44 = _tmpl$1();
                _$insert(_el$44, () => objective().progress);
                return _el$44;
              }
            }), null);
            return _el$41;
          })()
        }), null);
        _$insert(_el$5, _$createComponent(Show, {
          get when() {
            return (props.mission?.objectives.length ?? 0) > 1;
          },
          get children() {
            var _el$6 = _tmpl$2();
            _$insert(_el$6, _$createComponent(For, {
              get each() {
                return props.mission?.objectives ?? [];
              },
              children: line => _$createComponent(Show, {
                get when() {
                  return line.id !== props.mission?.objective?.id;
                },
                get children() {
                  var _el$45 = _tmpl$12(),
                    _el$46 = _el$45.firstChild,
                    _el$47 = _el$46.nextSibling;
                  _$insert(_el$46, () => OBJECTIVE_MARKS[line.status]);
                  _$insert(_el$47, () => line.label);
                  _$insert(_el$45, _$createComponent(Show, {
                    get when() {
                      return line.progress;
                    },
                    get children() {
                      var _el$48 = _tmpl$11();
                      _$insert(_el$48, () => line.progress);
                      return _el$48;
                    }
                  }), null);
                  _$effect(() => _$className(_el$45, `hud__objectives-row hud__objectives-row--${line.status}`));
                  return _el$45;
                }
              })
            }));
            return _el$6;
          }
        }), null);
        _$insert(_el$5, _$createComponent(Show, {
          get when() {
            return missionOutcomeLine(props.mission?.outcome ?? "inProgress");
          },
          children: line => (() => {
            var _el$49 = _tmpl$13();
            _$insert(_el$49, line);
            _$effect(() => _el$49.classList.toggle("hud__mission-verdict--failed", !!(props.mission?.outcome === "failure")));
            return _el$49;
          })()
        }), null);
        _$insert(_el$5, _$createComponent(Show, {
          get when() {
            return props.mission?.waypoint;
          },
          children: waypoint => (() => {
            var _el$50 = _tmpl$14(),
              _el$51 = _el$50.firstChild,
              _el$52 = _el$51.nextSibling,
              _el$53 = _el$52.firstChild,
              _el$54 = _el$53.nextSibling;
            _$insert(_el$53, () => waypoint().label);
            _$insert(_el$54, () => waypoint().distance);
            _$effect(_$p => _$setStyleProperty(_el$51, "transform", `rotate(${waypoint().bearingDeg}deg)`));
            return _el$50;
          })()
        }), null);
        return _el$5;
      }
    }), _el$34);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return !props.hideDigitalGauges;
      },
      get children() {
        return [(() => {
          var _el$7 = _tmpl$4(),
            _el$8 = _el$7.firstChild,
            _el$9 = _el$8.firstChild,
            _el$0 = _el$9.nextSibling,
            _el$1 = _el$0.firstChild,
            _el$10 = _el$8.nextSibling,
            _el$11 = _el$10.firstChild,
            _el$12 = _el$11.nextSibling,
            _el$13 = _el$12.firstChild,
            _el$14 = _el$10.nextSibling,
            _el$15 = _el$14.firstChild,
            _el$16 = _el$15.nextSibling,
            _el$17 = _el$16.firstChild,
            _el$18 = _el$17.nextSibling;
          _$insert(_el$1, () => props.hud.airspeedMph);
          _$insert(_el$13, () => props.hud.altitudeFt);
          _$insert(_el$17, () => props.hud.heading);
          _$insert(_el$16, () => props.hud.cardinal, null);
          return _el$7;
        })(), (() => {
          var _el$19 = _tmpl$5(),
            _el$20 = _el$19.firstChild,
            _el$21 = _el$20.firstChild,
            _el$22 = _el$21.nextSibling,
            _el$23 = _el$22.firstChild,
            _el$24 = _el$20.nextSibling,
            _el$25 = _el$24.firstChild,
            _el$26 = _el$25.nextSibling,
            _el$27 = _el$26.firstChild,
            _el$28 = _el$24.nextSibling,
            _el$29 = _el$28.firstChild,
            _el$30 = _el$29.nextSibling,
            _el$31 = _el$30.firstChild;
          _$insert(_el$23, () => props.hud.throttle);
          _$insert(_el$27, () => props.hud.fuel);
          _$insert(_el$31, () => props.hud.rounds);
          _$effect(_p$ => {
            var _v$ = !!props.hud.outOfFuel,
              _v$2 = !!props.hud.jammed;
            _v$ !== _p$.e && _el$24.classList.toggle("hud__gauge--warn", _p$.e = _v$);
            _v$2 !== _p$.t && _el$28.classList.toggle("hud__gauge--warn", _p$.t = _v$2);
            return _p$;
          }, {
            e: undefined,
            t: undefined
          });
          return _el$19;
        })()];
      }
    }), _el$34);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return props.combat.bombs;
      },
      children: bombs => (() => {
        var _el$55 = _tmpl$15(),
          _el$56 = _el$55.firstChild,
          _el$57 = _el$56.nextSibling,
          _el$58 = _el$57.firstChild,
          _el$59 = _el$58.nextSibling;
        _$insert(_el$58, () => bombs().remaining);
        _$insert(_el$57, () => bombs().remaining + bombs().released, null);
        _$effect(() => _el$55.classList.toggle("hud__bombs--empty", !!(bombs().remaining === 0)));
        return _el$55;
      })()
    }), _el$34);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return damageReportOf(props.combat);
      },
      children: damage => (() => {
        var _el$61 = _tmpl$16(),
          _el$62 = _el$61.firstChild,
          _el$63 = _el$62.nextSibling,
          _el$64 = _el$63.firstChild,
          _el$65 = _el$63.nextSibling,
          _el$66 = _el$65.firstChild,
          _el$67 = _el$65.nextSibling,
          _el$68 = _el$67.firstChild,
          _el$70 = _el$68.nextSibling,
          _el$69 = _el$70.nextSibling;
        _$insert(_el$65, () => damage().airframePercent, _el$66);
        _$insert(_el$61, _$createComponent(For, {
          get each() {
            return damage().tags;
          },
          children: tag => (() => {
            var _el$71 = _tmpl$17();
            _$insert(_el$71, tag);
            return _el$71;
          })()
        }), _el$67);
        _$insert(_el$67, () => damage().hitsTaken, _el$70);
        _$insert(_el$67, () => damage().hitsScored, null);
        _$effect(_p$ => {
          var _v$3 = !!damage().critical,
            _v$4 = `${damage().airframePercent}%`;
          _v$3 !== _p$.e && _el$61.classList.toggle("hud__damage--critical", _p$.e = _v$3);
          _v$4 !== _p$.t && _$setStyleProperty(_el$64, "width", _p$.t = _v$4);
          return _p$;
        }, {
          e: undefined,
          t: undefined
        });
        return _el$61;
      })()
    }), _el$34);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return props.combat.enemy;
      },
      children: enemy => (() => {
        var _el$72 = _tmpl$18(),
          _el$73 = _el$72.firstChild,
          _el$74 = _el$73.nextSibling,
          _el$75 = _el$74.firstChild,
          _el$76 = _el$75.nextSibling,
          _el$77 = _el$76.firstChild;
        _$insert(_el$75, () => enemy().range);
        _$insert(_el$76, () => enemy().clock, _el$77);
        _$insert(_el$76, () => enemy().relativeHeight, null);
        _$effect(_p$ => {
          var _v$5 = !!enemy().behind,
            _v$6 = !!enemy().destroyed,
            _v$7 = `rotate(${enemy().bearingDeg}deg)`;
          _v$5 !== _p$.e && _el$72.classList.toggle("hud__contact--behind", _p$.e = _v$5);
          _v$6 !== _p$.t && _el$72.classList.toggle("hud__contact--down", _p$.t = _v$6);
          _v$7 !== _p$.a && _$setStyleProperty(_el$73, "transform", _p$.a = _v$7);
          return _p$;
        }, {
          e: undefined,
          t: undefined,
          a: undefined
        });
        return _el$72;
      })()
    }), _el$34);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return props.hud.callout;
      },
      get children() {
        var _el$32 = _tmpl$6(),
          _el$33 = _el$32.firstChild;
        _$insert(_el$33, () => props.hud.callout);
        _$effect(() => _el$33.classList.toggle("hud__stall", !!props.hud.stalled));
        return _el$32;
      }
    }), _el$34);
    _$insert(_el$34, _$createComponent(For, {
      get each() {
        return props.messages;
      },
      children: message => (() => {
        var _el$78 = _tmpl$19();
        _$insert(_el$78, message);
        return _el$78;
      })()
    }));
    _$insert(_el$36, () => props.cameraLabel);
    _$insert(_el$35, _$createComponent(Show, {
      get when() {
        return props.paused;
      },
      get children() {
        return _tmpl$7();
      }
    }), null);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return _$memo(() => !!(props.mission || props.hideOutcomeBanner))() ? undefined : props.combat.banner;
      },
      children: banner => (() => {
        var _el$79 = _tmpl$20(),
          _el$80 = _el$79.firstChild,
          _el$81 = _el$80.nextSibling;
        _$insert(_el$80, banner);
        _el$81.$$click = () => props.onReturnToTitle();
        return _el$79;
      })()
    }), null);
    return _el$;
  })();
}
_$delegateEvents(["click"]);